export class DpomApproveRequest {
    purchaseOrderNumber: string;
    poLineItemNumber: number;
    itemNo: string;

}